import OrdersAPI from '@/API/orders-api'

export default {
  namespaced: true,
  state: {
    enabled: true,
    qr_link: '',
    fetched: false,
    noOrders: false,
  },

  getters: {
    isEnabled: (state: any) => state.enabled,
    qrLink: (state: any) => state.qr_link,
    noOrders: (state: any) => state.noOrders,
  },

  mutations: {
    SET_DATA(state: any, payload: any) {
      state.enabled = payload.enabled ?? true
      state.qr_link = payload.qr_link ?? ''
      state.noOrders = payload.noOrders ?? false
    },
  },

  actions: {
    async FETCH_DEPENDENCIES(context: any) {
      if (context.state.fetched) {
        return
      }
      try {
        const branchId = context.rootGetters['branches/currentBranchId']
        await context.dispatch('ordering/FETCH_SELLING_SETTINGS', branchId, { root: true })
        const data = await OrdersAPI.getSettings(branchId)
        context.commit('SET_DATA', data)
      } catch (err) {
        console.error(err)
      }
    },
    async UPDATE(context: any, payload: any) {
      // @ts-ignore
      try {
        return await OrdersAPI.updateOrder(payload)
      } catch (err: any) {
        return { response: 400, message: err?.message ?? '' }
      }
    },
    async GET_ORDER(context: any, payload: any) {
      // @ts-ignore
      try {
        return Promise.all([OrdersAPI.getOrder(payload.id), OrdersAPI.getOrderInvoice(payload.id)])
      } catch (err: any) {
        return { response: 400, message: err?.message ?? '' }
      }
    },
  },
}
